import React from 'react';
import { Loader2 } from 'lucide-react';

/** Route-level Suspense fallback */
export default function PageLoader({ label = 'Loading…' }) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 px-4 py-16 text-[#5c4a3a]" role="status" aria-live="polite">
      <Loader2 className="h-9 w-9 animate-spin text-amber-800" aria-hidden />
      <p className="font-marathi text-sm">{label}</p>
    </div>
  );
}

export function MapLoader() {
  return (
    <div className="flex h-[min(420px,55vh)] min-h-[240px] items-center justify-center rounded-xl border border-amber-500/25 bg-[#faf6ef]" role="status">
      <Loader2 className="h-8 w-8 animate-spin text-amber-800" aria-hidden />
    </div>
  );
}
